// extracted by mini-css-extract-plugin
module.exports = {"input":"SelectInput_input__2Kpgd","label":"SelectInput_label__T60ur"};